import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetAccountholderProfileRequest } from '@cash-web/shared-util-protos/squareup/cash/janus/api/AccountholderProfile.pb'
import { SetAccountholderProfileResponse } from '@cash-web/shared-util-protos/squareup/cash/janus/api/AccountholderProfile.pb'

export const setAccountholderProfileInternal = (
  request: SetAccountholderProfileRequest,
  options?: CashRequestOptions
) =>
  post<SetAccountholderProfileRequest, SetAccountholderProfileResponse>(
    '/2.0/cash/set-accountholder-profile-internal',
    request,
    { ...options, rejectOnError: true }
  )
